import { Article, ArticleErpInfo, WholesalerArticle } from "@tm/models"
import { useMemo } from "react"

export function useIsNoTeccomRequestAvailable(
    erpInfos: ArticleErpInfo[],
    articles: Article[],
    wholesalerArticles?: WholesalerArticle[],
    isFrontendFiltered?: boolean
) {
    const isNoTeccomRequestAvailable = useMemo(() => {
        const isNoTeccomRequestAvailableInArticles = !articles.some((article) =>
            erpInfos.find((t) => t.key.internalId === article.internalId && t.state === "success" && t.response.isTeccomRequestAvailable)
        )

        const isNoTeccomRequestAvailableInWholesalerArticles =
            isFrontendFiltered ||
            !wholesalerArticles?.some((article) =>
                erpInfos.find(
                    (t) =>
                        t.request.wholesalerArticleNumber === article.wholesalerArticleNumber &&
                        t.state === "success" &&
                        t.response.isTeccomRequestAvailable
                )
            )

        return isNoTeccomRequestAvailableInArticles && isNoTeccomRequestAvailableInWholesalerArticles
    }, [articles, isFrontendFiltered, wholesalerArticles, erpInfos])

    return isNoTeccomRequestAvailable
}
